var avatarFallback = 'fx_c76f37be_cp0sj71';
var avatarFallbackBackground = 'var(--fx_c76f37be_cp0sj70)';

export { avatarFallback, avatarFallbackBackground };
//# sourceMappingURL=fallback.vanilla.mjs.map
